"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var compose = require('../../hoc/compose');

var RadioButtons = require('../radioButtons');

var imageAndTextTemplate = require('../imageAndTextTemplate');

var displayNames = require('../displayNames');

var RadioButtonsWithIllustration = function RadioButtonsWithIllustration(_ref) {
  var getClassName = _ref.getClassName,
      automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options;
  return /*#__PURE__*/React.createElement(RadioButtons, {
    className: getClassName('image-and-text-radio-buttons'),
    automationId: automationId,
    dataHook: dataHook,
    value: value,
    onChange: onChange,
    labelTemplate: imageAndTextTemplate,
    options: options
  });
};

RadioButtonsWithIllustration.displayName = displayNames.RADIO_BUTTONS_WITH_ILLUSTRATION;
RadioButtonsWithIllustration.propTypes = {
  /** hook for testing purposes */
  dateHook: PropTypes.string,

  /** The value of the selected options */
  value: PropTypes.string.isRequired,

  /** Callback function (options) => {}, triggered on option selection change */
  onChange: PropTypes.func.isRequired,

  /** List of options to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    image: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string
  })).isRequired
};
module.exports = compose(RadioButtonsWithIllustration);